// @flow
import type { CompanyBranch } from "../../lib/Types";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import React from "react";
import { Container, SearchHeading, Body } from "./Theme";
import styled, { css } from "styled-components";
import Input from "../../Input";
import Button from "../../Button";
import { DateRangePicker } from "react-dates";
import { fetchGraphs } from "../../../lib/fetching/FetchGraphs";
import moment, { ISO_8601 } from "moment";
import CompanyBranchDropDown from "../../crm/CompanyBranchDropDown";
import DataFieldFilter from "../DataFieldFilter";
import DropDown from "../../DropDown";
import CompanyDropDown from "../../crm/CompanyDropDown";
import ProductSearch from "../ProductSearch";
import TestnameInputMulti from "../../testing/TestnameInputMulti";
import DataFieldsDropDown from "../DataFieldsDropDown";
import { renderMonthElement } from "../../common/CalendarUtils";
// import AttributeFilter from "./AttributeFilter";

type Props = {
  company_id: ?number,
  canFindCompany: boolean,
  onLoad: ?Function,
  onError: ?Function,
  clientView: boolean,
};

type State = {
  company_id: ?number,
  loading: boolean,
  product_name: ?string,
  company_branch_id: ?number,
  start_date: ?Object,
  end_date: ?Object,
  startDateFocused: boolean,
  endDateFocused: boolean,
  received: string,
  expanded: boolean,
};

const OuterContainer = styled(Container)``;

const Row = styled.div.attrs({ className: "row" })`
  padding-bottom: 10px;
`;

const Column = styled.div.attrs({ className: "col-md-3" })``;
const FullColumn = styled.div.attrs({ className: "col-md-12" })``;

export default class Search extends React.Component<Props, State> {
  state = {
    company_id: this.props.company_id,
    loading: false,
    product_name: "",
    company_branch_id: null,
    start_date: moment().subtract(100, "days"),
    end_date: moment(),
    startDateFocused: false,
    endDateFocused: false,
    product_ids: [],
    test_name_ids: [],
    breakdownDataFields: [],
    expanded: true,
  };

  canSubmit = (): boolean => {
    const { clientView } = this.props;
    const { start_date, end_date, product_ids, test_name_ids } = this.state;
    if (!start_date || !end_date) return false;
    if (end_date < start_date) return false;
    if (test_name_ids.length == 0) return false;
    // if (clientView && product_ids.length == 0) return false;
    return true;
  };

  fetchData = () => {
    const { onLoad } = this.props;
    const {
      company_id,
      product_name,
      start_date,
      end_date,
      company_branch_id,
      product_ids,
      test_name_ids,
      breakdownDataFields,
    } = this.state;
    this.setState({ loading: true });
    const params = {
      company_id,
      company_branch_ids: company_branch_id ? [company_branch_id] : [],
      start_date,
      end_date,
      product_ids,
      test_name_ids,
      data_field_names_breakdown: breakdownDataFields,
      data_field_query_params: this.dataFieldFilter ? this.dataFieldFilter.queryParams() : [],
    };
    fetchGraphs(params).then((json) => {
      if (json.errors) {
        alert(json.errors);
        return;
      }
      onLoad(json.folder);
      this.setState({ expanded: false, loading: false });
    });
  };

  branchChanged = (branch: CompanyBranch) => {
    this.setState({ company_branch_id: branch ? branch.id : undefined });
  };

  render() {
    const { canFindCompany } = this.props;
    const {
      company_id,
      loading,
      product_name,
      start_date,
      end_date,
      startDateFocused,
      endDateFocused,
      company_branch_id,
      breakdownDataFields,
      expanded,
    } = this.state;
    return (
      <OuterContainer>
        <SearchHeading>
          <i className="fa fa-search" />
          &nbsp;&nbsp; {I18n.t("search")}
        </SearchHeading>
        <Body>
          <Row style={{ display: expanded ? "none" : "inherit", padding: 0, paddingTop: 8 }}>
            <Column>
              <Button
                title={I18n.t("change_search_criteria")}
                onClick={() => this.setState({ expanded: true })}
              />
            </Column>
          </Row>
          <Row style={{ display: expanded ? "inherit" : "none" }}>
            {canFindCompany && (
              <Column>
                <label>{I18n.t("company")}</label>
                <CompanyDropDown
                  onChange={(company_id) =>
                    this.setState({ company_id, company_branch_id: null })
                  }
                />
              </Column>
            )}
            {company_id && (
              <Column>
                <label>{I18n.t("select_branch")}</label>
                <CompanyBranchDropDown
                  key={company_id}
                  company_id={company_id}
                  onBranchChange={this.branchChanged}
                  value={company_branch_id}
                  includeBlank={true}
                  blankLabel={I18n.t("all_branches")}
                />
              </Column>
            )}
            <Column className="col-md-6">
              <label>{I18n.t("registered_between")}</label>
              <br />
              <DateRangePicker
                startDateId="start_date"
                startDate={start_date}
                endDateId="end_date"
                endDate={end_date}
                numberOfMonths={1}
                onDatesChange={({ startDate, endDate }) =>
                  this.setState({ start_date: startDate, end_date: endDate })
                }
                focusedInput={this.state.focusedInput || null}
                onFocusChange={(focusedInput) => this.setState({ focusedInput })}
                showClearDates={true}
                isOutsideRange={() => false}
                hideKeyboardShortcutsPanel={true}
                displayFormat="DD MMM YYYY"
                renderMonthElement={renderMonthElement}
              />
            </Column>
            {company_id &&
              false && (
                <Column>
                  <label>{I18n.t("breakdown_by_attribute")}</label>
                  <br />
                  <DataFieldsDropDown
                    values={breakdownDataFields}
                    onChange={(values) => this.setState({ breakdownDataFields: values })}
                    company_id={company_id}
                    company_branch_id={company_branch_id}
                  />
                </Column>
              )}
          </Row>
          {company_id && (
            <Row
              style={{
                paddingBottom: 10,
                paddingTop: 5,
                display: expanded ? "inherit" : "none",
              }}
            >
              <FullColumn>
                <DataFieldFilter
                  ref={(ref) => (this.dataFieldFilter = ref)}
                  company_id={company_id}
                  company_branch_id={company_branch_id}
                />
              </FullColumn>
            </Row>
          )}
          <Row style={{ display: expanded ? "inherit" : "none" }}>
            <FullColumn>
              <label>{I18n.t("select_test_names")}</label>
              <br />
              <TestnameInputMulti
                onChange={(test_name_ids) => this.setState({ test_name_ids })}
              />
            </FullColumn>
          </Row>
          <Row style={{ display: expanded ? "inherit" : "none" }}>
            <FullColumn>
              <label>{I18n.t("select_products")}</label>
              <br />
              <ProductSearch
                company_id={company_id}
                company_branch_id={company_branch_id}
                onChange={(product_ids) => this.setState({ product_ids })}
              />
            </FullColumn>
          </Row>
          <Row
            style={{ paddingBottom: 0, paddingTop: 5, display: expanded ? "inherit" : "none" }}
          >
            <Column>
              <Button
                disabled={!this.canSubmit()}
                title={loading ? I18n.t("loading") : I18n.t("view_graphs")}
                icon="fa-search"
                onClick={this.fetchData}
                primary
              />
            </Column>
          </Row>
        </Body>
      </OuterContainer>
    );
  }
}
